{
  "panel": {
    "title": "Concierge",
    "assistantTitle": "Espace assistant",
    "subtitle": "Posez des questions ou décrivez ce dont vous avez besoin.",
    "empty": "Aucun message pour le moment.",
    "emptyHint": "Indiquez au concierge sur quoi vous travaillez pour commencer.",
    "loading": "Chargement de la conversation...",
    "loadFailed": "Impossible de charger le chat.",
    "uploadHint": "Importez une description de tâche, puis cliquez sur <strong>Générer le plan</strong> pour commencer. Le modèle de sortie est facultatif — la structure du plan peut être dérivée de la description de la tâche et des connaissances du domaine.",
    "ariaSendMessage": "Envoyer le message",
    "ariaClose": "Fermer",
    "feedbackPlaceholder": "Décrivez ce qui doit être modifié ou amélioré...",
    "verticalRequired": "Aucune verticale configurée pour cet espace de travail. Les outils de test nécessitent une verticale (par ex. liquidity_stress).",
    "ariaStop": "Arrêter la génération"
  },
  "input": {
    "placeholder": "Saisissez un message...",
    "placeholderTestRun": "Exécution de test en cours...",
    "placeholderProcessing": "Traitement...",
    "placeholderCorpusMutating": "La discussion est suspendue pendant le traitement de vos fichiers.",
    "placeholderNoPlan": "Le chat est disponible une fois le plan généré...",
    "placeholderDataReady": "N'hésitez pas à poser des questions sur les données importées...",
    "placeholderPlanFeedback": "Donnez votre avis sur le plan...",
    "send": "Envoyer",
    "sending": "Envoi...",
    "sendFailed": "Impossible d'envoyer le message.",
    "attach": "Joindre",
    "stop": "Arrêter",
    "newConversation": "Nouvelle conversation",
    "uploadTaskFirstTooltip": "Veuillez d'abord importer une description de tâche",
    "planGenInProgressTooltip": "Génération du plan en cours",
    "micStart": "Démarrer la saisie vocale",
    "micStop": "Terminer la saisie vocale",
    "micCancel": "Annuler la saisie vocale",
    "micRequestingPermission": "Autorisez l’accès au microphone…",
    "micListening": "À l’écoute…",
    "micSpeechDetected": "À l’écoute de votre message…",
    "micTranscribing": "Transcription en cours…",
    "micDone": "Message vocal envoyé",
    "micLevel": "Niveau du microphone",
    "micUnsupported": "Ce navigateur ne prend pas en charge la saisie vocale.",
    "placeholderDataReady_auditing": "Posez une question sur les pièces justificatives de l’audit…",
    "placeholderPlanFeedback_auditing": "Posez une question sur l’audit ou partagez vos commentaires…"
  },
  "message": {
    "uploadTaskFirst": "Veuillez importer une description de tâche pour commencer.",
    "you": "Vous",
    "concierge": "Concierge",
    "thinking": "Réflexion...",
    "typing": "Le concierge écrit...",
    "edited": "Modifié",
    "delivered": "Remis",
    "failed": "Échec de l'envoi",
    "retry": "Réessayer",
    "copy": "Copier",
    "copied": "Copié",
    "stopped": "Arrêté",
    "notStoppable": "Cette réponse ne peut plus être arrêtée.",
    "finishedBeforeStop": "Cette réponse s’est terminée avant de pouvoir être arrêtée.",
    "planUpdatedFallback": "Plan mis à jour selon vos commentaires.",
    "planUpdatedWithItems_one": "J'ai mis à jour le plan avec {{count}} élément.",
    "planUpdatedWithItems_other": "J'ai mis à jour le plan avec {{count}} éléments.",
    "planUpdateFailedFallback": "Échec de la mise à jour du plan. Veuillez réessayer."
  },
  "completeness": {
    "freshness": {
      "unknown": "Cette évaluation antérieure n’a pas de version des preuves enregistrée.",
      "superseded": "Les preuves ont changé depuis cette évaluation."
    },
    "title": "Complétude des données",
    "checking": "Vérification des données...",
    "ready": "Prêt à planifier",
    "needsMore": "Données supplémentaires requises",
    "verdictReady": "Vos données couvrent les sections requises.",
    "verdictNeedsMore": "Certaines sections nécessitent des données supplémentaires.",
    "verdictPending": "Évaluation de vos données...",
    "viewDetails": "Voir les détails",
    "rerun": "Revérifier",
    "rerunning": "Revérification...",
    "addMoreFiles": "Ajouter plus de fichiers",
    "proceedAnyway": "Continuer quand même",
    "missingSection": "Données manquantes pour : {{section}}",
    "loadFailed": "Impossible de charger la vérification de complétude.",
    "lastChecked": "Dernière vérification {{time}}",
    "dataCoverage": "Couverture des données",
    "verdicts": {
      "comprehensive": "Complète",
      "adequate": "Adéquate",
      "partial": "Partielle",
      "insufficient": "Insuffisante"
    },
    "moreGaps_one": "+{{count}} lacune supplémentaire",
    "moreGaps_other": "+{{count}} lacunes supplémentaires",
    "moreActions_one": "+{{count}} action supplémentaire",
    "moreActions_other": "+{{count}} actions supplémentaires",
    "moreSuggestions_one": "+{{count}} suggestion supplémentaire",
    "moreSuggestions_other": "+{{count}} suggestions supplémentaires",
    "anyFormat": "Tous formats",
    "recommendedUploads": "Imports recommandés",
    "quickActions": "Actions rapides",
    "missingDocuments": "Documents manquants",
    "missingData": "Données manquantes",
    "readyForReport": "Prêt à générer le rapport",
    "considerMoreData": "Envisagez d’ajouter des données pour de meilleurs résultats",
    "moreFilesNeeded": "Davantage de fichiers sont nécessaires pour des résultats fiables"
  },
  "system": {
    "dataCompletenessFailed": "La vérification de complétude des données a échoué. Vous pouvez poursuivre la génération du rapport, mais la couverture des données est inconnue.",
    "completenessAssessmentComplete": "L'évaluation de la complétude des données est terminée.",
    "dataIngestionComplete": "Vos fichiers sources ont été traités et indexés. Les données sont prêtes pour l'analyse.",
    "planGenerated": "J'ai généré un plan d'exécution avec {{itemCount}} sections basé sur votre description de tâche. Veuillez examiner la structure du plan ci-dessous.",
    "planApproved": "Plan approuvé ! Vous pouvez maintenant importer vos fichiers de données pour poursuivre la génération du rapport.",
    "generationResumed": "L'arrêt d'infrastructure a été levé. Vous pouvez régénérer les sections échouées individuellement ou relancer la génération des sections restantes via le bouton principal Générer.",
    "planFeedbackProgress": "Traitement de vos commentaires sur le plan — révision des sections..."
  },
  "history": {
    "today": "Aujourd'hui",
    "yesterday": "Hier",
    "older": "Plus ancien"
  },
  "senderLabel": {
    "you": "VOUS",
    "bennie": "Bennie",
    "bennieDataSearch": "Bennie (recherche de données)"
  },
  "statusIndicators": {
    "reconnecting": "Connexion interrompue — vérification que votre réponse est bien arrivée…",
    "regeneratingSection": "Réécriture de la section {{sectionId}} — cela prend généralement quelques minutes.",
    "regeneratingSectionUnnamed": "Réécriture de la section — cela prend généralement quelques minutes.",
    "regeneratingElapsed": "{{minutes}} min écoulées",
    "querying": "Interrogation de la base de connaissances…",
    "connecting": "Établissement des liens…",
    "crunching": "Analyse des détails…",
    "phrases": [
      "Réflexion en cours…",
      "Traitement de votre requête…",
      "Travail en cours…",
      "Revue du contexte…",
      "Établissement des liens…",
      "Synthèse des informations…",
      "Formulation d'une réponse…",
      "Analyse de votre saisie…",
      "Construction d'une réponse…",
      "Analyse des détails…",
      "Recoupement des sources…",
      "Assemblage des constats…",
      "Mise en forme des idées…",
      "Pesée des options…",
      "Approfondissement…",
      "Presque terminé…",
      "Un instant, je vous prie…",
      "Bonne question…",
      "Recherche dans vos documents…",
      "Interrogation de la base de connaissances…",
      "Extraction des données pertinentes…",
      "Recherche des exigences de données…",
      "Évaluation de la structure du plan…",
      "Vérification de l'alignement réglementaire…",
      "Un moment…",
      "Celle-ci est intéressante…",
      "Beaucoup à considérer ici…",
      "Revue des implications de périmètre…",
      "Cartographie du flux documentaire…",
      "Analyse des fichiers sources…"
    ]
  },
  "refusal": {
    "planAlreadyApproved": {
      "report": "Le plan du rapport a été approuvé et est verrouillé : il ne peut plus être modifié.",
      "de_checklist": "La liste de contrôle de conception effective a été approuvée et est verrouillée : elle ne peut plus être modifiée.",
      "oe_checklist": "La liste de contrôle de fonctionnement effectif a été approuvée et est verrouillée : elle ne peut plus être modifiée."
    },
    "planRevisionIntegrityFailed": "La révision a échoué aux contrôles d’intégrité du plan. Votre plan est inchangé. Veuillez préciser les modifications souhaitées.",
    "planRevisionSavedResponseFailed": "Votre révision a été enregistrée, mais sa confirmation a échoué. Vérifiez le plan enregistré avant de demander une autre modification.",
    "runItemRegenDisabled": "Les résultats de conception effective et de fonctionnement effectif ne peuvent pas être régénérés élément par élément. Pour les modifier, mettez à jour les éléments probants et relancez toute la phase."
  }
}
